import { FeedbackIssueTypeSlug } from "@/src/components/organisms/FeedbackForm/feedbackSubjectOptions";

import { api, apiPaths, publicApi } from "../../api";

export interface FeedbackRequest {
  site: string;
  postedBy: "seller" | "dealer";
  issueType: FeedbackIssueTypeSlug;
  name?: string;
  email: string;
  mobile?: string;
  message: string;
}

export interface FeedbackResponse {
  success: boolean;
  message: string;
  caseId: string;
}

export interface FeedbackImageResponse {
  success: boolean;
  message: string;
}

const getClient = (isAuthenticated: boolean) =>
  isAuthenticated ? api : publicApi;

export const postFeedback = async (
  data: FeedbackRequest,
  isAuthenticated: boolean
): Promise<FeedbackResponse> => {
  return getClient(isAuthenticated)
    .url(apiPaths.FEEDBACK)
    .post(data)
    .json<FeedbackResponse>();
};

export const uploadFeedbackImage = async (
  caseId: string,
  file: File,
  isAuthenticated: boolean
): Promise<FeedbackImageResponse> => {
  const formData = new FormData();
  formData.append("feedbackImage", file);

  return getClient(isAuthenticated)
    .url(`${apiPaths.FEEDBACK}/image/${caseId}`)
    .body(formData)
    .post()
    .json<FeedbackImageResponse>();
};
